import gql from "graphql-tag"
import ScheduledRecognitionFragment from "../fragments/ScheduledRecognition"
const mutation = gql`
  mutation createScheduledRecognition($scheduledRecognition: CreateScheduledRecognitionInput!) {
    createScheduledRecognition(recognition: $scheduledRecognition) {
      ...ScheduledRecognition
    }
  }
  ${ScheduledRecognitionFragment}
`
export default mutation
